import { useTranslation } from 'react-i18next'

import Section from '@/components/atomic/molecules/Section'
import Text from '@/components/atomic/atoms/Text'

import type { HospitalView } from '@/features/hospital/types/hospital.type'

interface HospitalAccessSectionProps {
  hospital: HospitalView
}

export const HospitalAccessSection = ({ hospital }: HospitalAccessSectionProps) => {
  const { t } = useTranslation()

  return (
    <Section title={t('templates.hospitalDetail.accessTitle')}>
      <Text element="p" type="caption2">
        {hospital.location.wayToCome}
      </Text>
    </Section>
  )
}
